export default __webpack_public_path__ + "static/media/Inside.5823fcb8.jpg";